import { render, staticRenderFns } from "./Pie2.vue?vue&type=template&id=7b9266c0&scoped=true"
import script from "./Pie2.vue?vue&type=script&lang=js"
export * from "./Pie2.vue?vue&type=script&lang=js"
import style0 from "./Pie2.vue?vue&type=style&index=0&id=7b9266c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9266c0",
  null
  
)

export default component.exports